import { css } from 'aphrodite';
import { Tabs } from 'radix-ui';
import * as React from 'react';
import { Industry } from '../../../../extViewmodels';
import { TabContentIndustryCategorizedCards } from '../CategoriesByIndustry/TabContentIndustryCategorizedCards';
import { AdminIndustryTemplatesBlogsTabContent } from './AdminIndustryTemplateBlogsTabContent';
import { AdminIndustryTemplatesEmailTabContent } from './AdminIndustryTemplatesEmailTabContent';
import { AdminIndustryTemplatesSocialTabContent } from './AdminIndustryTemplatesSocialTabContent';
import { styleSheet } from './styles';

enum TabValue {
	Email = 'Email',
	Social = 'Social',
	Cards = 'Cards',
	Blogs = 'Blogs',
}

export function CampaignTemplatesByIndustry({ industry }: { industry: Industry }) {
	const [activeTabValue, setActiveTabValue] = React.useState<TabValue>(TabValue.Email);
	return (
		<Tabs.Root
			className={css(styleSheet.root)}
			value={activeTabValue}
			onValueChange={value => setActiveTabValue(value as TabValue)}
		>
			<Tabs.List className={css(styleSheet.tabList)}>
				<Tabs.Trigger
					className={css(styleSheet.tabTrigger, activeTabValue === TabValue.Email && styleSheet.tabTriggerActive)}
					value={TabValue.Email}
				>
					Email Campaigns
				</Tabs.Trigger>
				<Tabs.Trigger
					className={css(styleSheet.tabTrigger, activeTabValue === TabValue.Social && styleSheet.tabTriggerActive)}
					value={TabValue.Social}
				>
					Social Media
				</Tabs.Trigger>
				<Tabs.Trigger
					className={css(styleSheet.tabTrigger, activeTabValue === TabValue.Cards && styleSheet.tabTriggerActive)}
					value={TabValue.Cards}
				>
					Cards
				</Tabs.Trigger>
				<Tabs.Trigger
					className={css(styleSheet.tabTrigger, activeTabValue === TabValue.Blogs && styleSheet.tabTriggerActive)}
					value={TabValue.Blogs}
				>
					Blogs
				</Tabs.Trigger>
			</Tabs.List>
			<Tabs.Content value={TabValue.Email}>
				<AdminIndustryTemplatesEmailTabContent industry={industry} />
			</Tabs.Content>
			<Tabs.Content value={TabValue.Social}>
				<AdminIndustryTemplatesSocialTabContent industry={industry} />
			</Tabs.Content>
			<Tabs.Content value={TabValue.Cards}>
				<TabContentIndustryCategorizedCards industry={industry} />
			</Tabs.Content>
			<Tabs.Content value={TabValue.Blogs}>
				<AdminIndustryTemplatesBlogsTabContent industry={industry} />
			</Tabs.Content>
		</Tabs.Root>
	);
}
